import { setTargetingParams, enableDebug } from "@lululemon/mwa-launch-darkly";
import getCorrelationId from "@lululemon/ecom-core/src/util/correlation-id";
import { getUsrLocaleStandard } from "@lululemon/ecom-common/src/util/locale-utils";
import { publicConfig } from "@lululemon/ecom-common/src/util/public-config";
import Cookies from "js-cookie";
function initializeMwaLaunchDarkly() {
    // Browser only
    if (typeof document === "undefined") {
        return;
    }
    // Initialize debugger and targeting params for mwa-launch-darkly
    try {
        var ref;
        // adds ld_ff to window object allowing direct access to flagCache allowing flag overriding
        if (publicConfig === null || publicConfig === void 0 ? void 0 : (ref = publicConfig.launchDarkly) === null || ref === void 0 ? void 0 : ref.enableDebug) {
            enableDebug();
        }
        // This block defines the user context object sent with launch darkly requests when using mwa-launch-darkly
        var correlationId = getCorrelationId();
        var previewId = localStorage.getItem("ld-previewer-id");
        var locale = getUsrLocaleStandard();
        var sessionCount = parseInt(Cookies.get("kampyleUserSessionsCount") || 0, 10);
        var targetingParams = {
            key: "ecom-web-app",
            custom: {
                targetable: true
            }
        };
        if (correlationId) {
            // Enables % rollouts
            targetingParams.custom.correlationId = correlationId;
        }
        if (previewId) {
            /*
      // 1:1 opt-in targeting for devs/internal early access
      // For more info and to learn how to configure in Launch Darkly, see:
      // https://lululemon.atlassian.net/wiki/spaces/~751832640/pages/3245474837/Launchdarkly+-+Employee+Preview+Configuration
      */ targetingParams.custom.previewId = previewId;
        }
        if (locale) {
            // Enables locale based targeting
            targetingParams.custom.locale = locale;
        }
        if (sessionCount !== null && !isNaN(sessionCount)) {
            // Enables session count based targeting
            targetingParams.custom.sessionCount = sessionCount;
        }
        targetingParams.custom.isLoggedIn = !!Cookies.get("lll_oidc_token");
        setTargetingParams({
            targetingParams: targetingParams
        });
    } catch (err) {
        console.warn("\uD83D\uDE80 error setting LD targeting params, LD flags may not be targetable");
    }
}
export { initializeMwaLaunchDarkly };
